import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AtInternetService } from '../../../services/at-internet.service';
import { ClaimService } from '../../../services/claim.service';
import { phoneRegex4 } from "../../../../assets/commonAssets/commonConstant.js"
import { ErrorStateMatcher } from '@angular/material/core';

@Component({
  selector: 'app-claim',
  templateUrl: './claim.component.html',
  styleUrls: ['./claim.component.scss']
})
export class ClaimComponent implements OnInit {

  maxLength = 60;
  userInformations: FormGroup;
  claimSended: boolean = false;
  show = false;
  confirmValidParentMatcher = new ConfirmValidParentMatcher();
  isEmailInputValid : boolean;
  emailRegex =new RegExp('^[a-zA-Z--9._%+-]+@[a-zA-Z-0-9.-]+\\.[a-za-zA-Z-]{2,4}$');
  phoneRegex = new RegExp("^(?:(?:\\+|00)33|0)\s*[1-9][0-9]{8}$");
  isPhoneInputValid : boolean;

  constructor(@Inject(MAT_DIALOG_DATA) public data,
    public dialogRef: MatDialogRef<ClaimComponent>,
    private claimService: ClaimService,
    private atInternetService: AtInternetService) {
  }

  ngOnInit() {
    this.initForm();
    this.fillForm();
    this.emailValidCheck(this.data.parcelInformations.parcel.consigneeInformation.email.toLowerCase())
    this.phoneValidCheck(this.data.parcelInformations.parcel.consigneeInformation.mobilePhone)
    if (this.data.reasonCode == "AF") {
      this.atInternetService.generatePage(
        this.data.tag,
        'reclamation_absence_facteur_formulaire',
        'reclamation_absence_facteur_formulaire'
      );
    } else if (this.data.reasonCode == "CL") {
      this.atInternetService.generatePage(
        this.data.tag,
        'reclamation_contestation_livraison_formulaire',
        'reclamation_contestation_livraison_formulaire'
      );
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  isMobile() {
    var width = window.outerWidth;

    if (width < 600) {
      return true
    }
    return false;
  }

  initForm(): void {
    this.userInformations = new FormGroup({
      firstname: new FormControl({ value: '' }, Validators.required),
      lastname: new FormControl({ value: '' }, Validators.required),
      email: new FormControl(
        { value: '' },
        [Validators.required, Validators.pattern(this.emailRegex)]),
      phoneNumber: new FormControl({ value: '' }, [Validators.required, Validators.pattern(phoneRegex4)]),
    });
  }

  fillForm(): void {
    this.userInformations.get('firstname').setValue(this.data.parcelInformations.parcel.consigneeInformation.name);
    this.userInformations.get('lastname').setValue(this.data.parcelInformations.parcel.consigneeInformation.firstName);
    this.userInformations.get('email').setValue(this.data.parcelInformations.parcel.consigneeInformation.email.toLowerCase());
    this.userInformations.get('phoneNumber').setValue(this.data.parcelInformations.parcel.consigneeInformation.mobilePhone);
  }

  validate() {
    let claimRequest = {
      "lastname": this.userInformations.value.lastname,
      "firstname": this.userInformations.value.firstname,
      "email": this.userInformations.value.email,
      "phoneNumber": this.userInformations.value.phoneNumber,
      //Informations recuperees du WS Timeline
      "parcelNumber": (this.data.parcelInformations.parcel.parcelNumber) ? this.data.parcelInformations.parcel.parcelNumber : this.data.parcelInformations.parcel.parcelNumberInput,
      "accountNumber": "999999", //à la demande de Lydie
      "receiverLastname": this.userInformations.value.lastname, //Demande faite par Lydie 07/06/21
      "receiverFirstName": this.userInformations.value.firstname, //Demande faite par Lydie 07/06/21
      "deliveryAddress1": this.data.parcelInformations.parcel.consigneeInformation.address.address0,
      "deliveryAddress2": this.data.parcelInformations.parcel.consigneeInformation.address.address1,
      "deliveryAddress3": this.data.parcelInformations.parcel.consigneeInformation.address.address2,
      "deliveryAddress4": this.data.parcelInformations.parcel.consigneeInformation.address.address3,
      "deliveryZipCode": this.data.parcelInformations.parcel.consigneeInformation.address.zipCode,
      "deliveryCity": this.data.parcelInformations.parcel.consigneeInformation.address.city,
      "deliveryCountryCode": this.data.parcelInformations.parcel.consigneeInformation.address.countryCodeISO,
      "reasonCode": this.data.reasonCode
    }

    this.claimService.checkClaim(claimRequest).subscribe(
      res => {
        if (res.status === "0") {
          this.claimService.sendClaim(claimRequest).subscribe(
            response => {
              this.data.changeRefNumber(response.claimNumber);
              if (response.status === "0") {
                this.claimSended = true;
              } else {
                //TODO Gerer les erreurs renvoyer par le WS la méthode sendClaim
              }
            });
        } else {
          //TODO Gerer les erreurs renvoyer par le WS sur la méthode checkClaim
        }
      }
    );
  }

  emailValidCheck(email) {
    if (this.emailRegex.test(email.toLowerCase())) {
      this.isEmailInputValid = true;
    } else {
      this.isEmailInputValid = false;
    }
  }
  phoneValidCheck(phone) {
    if (this.phoneRegex.test(phone)) {
      this.isPhoneInputValid = true;
    } else {
      this.isPhoneInputValid = false;
    }
  }
}
/**
 * Custom ErrorStateMatcher which returns true (error exists) when the parent form group is invalid and the control has been touched
 */
 export class ConfirmValidParentMatcher implements ErrorStateMatcher {
  isErrorState(control: FormControl | null, form: FormGroupDirective | NgForm | null): boolean {
    return !!(control && control.invalid);
  }
}
